import type { FormKitInputs } from "@/hooks/common/use-formkit.ts";

import { z } from "zod";

// WM-4677 : Deprecate and replace with definitions in backoffice-site-v2-api

export const DTO_KEYS = {
  country: "country",
  addressType: "addressType",
  buildingMoreThan2Years: "buildingMoreThan2Years",
} as const satisfies Record<keyof FormKitInputs, string>;

export enum SiteBusinessSegment {
  ORGANIZATION = "ORGANIZATION",
  HOUSEHOLDER = "HOUSEHOLDER",
  UNKNOWN = "UNKNOWN",
}

export enum ESubscriberOffer {
  PREMIUM = "PREMIUM",
  BASIC = "BASIC",
  PREMIUM_PENDING_SIGNATURE = "PREMIUM_PENDING_SIGNATURE",
}

export enum ESiteDeactivatedState {
  DEACTIVATED_WITH_MYV = "DEACTIVATED_WITH_MYV",
  DEACTIVATED_WITHOUT_MYV = "DEACTIVATED_WITHOUT_MYV",
}

export const geocodedAddressDtoSchema = z.object({
  id: z.number().nullish(),
  administrativeDivision: z.string().array(),
  cityCode: z.string().nullable(),
  country: z
    .object({
      label: z.string(),
      isoCode: z.string(),
    })
    .nullable(),
  externId: z.string().nullish(),
  geocoding: z
    .object({
      latitude: z.number(),
      longitude: z.number(),
    })
    .nullable(),
  inseeCode: z.string().nullable(),
  label: z.string(),
  provider: z.string().nullable(),
  score: z.number().nullable(),
  street: z.string().nullish(),
  streetNumber: z.string().nullish(),
  city: z.string().nullable(),
  zipCode: z.string().nullable(),
});

export const postalAddressDtoSchema = z.object({
  address: z.string().nullable(),
  addressComplement: z.string().nullable(),
  digicode: z.string().nullable(),
  building: z.string().nullable(),
  level: z.number().nullable(),
  stairway: z.string().nullable(),
  cityCode: z.string().nullable(),
  zipCode: z.string().nullable(),
  city: z.string().nullable(),
});

// @deprecated Remove when SiteModel can be used everywhere (instead of SiteModelWithLegacyAddresses)
export type TGeocodedAddressDto = z.infer<typeof geocodedAddressDtoSchema>;
export type TPostalAddressDto = z.infer<typeof postalAddressDtoSchema>;
